import React from 'react';
import './FormField.css';

const FormField = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  placeholder = '',
  required = false,
  disabled = false,
  className = '',
  options = [], // Para select
  rows = 3, // Para textarea
  min,
  max,
  step,
  inputMode,
  error,
  helpText,
  icon
}) => {
  const fieldId = `field-${name}`;

  const getFieldClassName = () => {
    let classes = 'form-field-input';
    if (error) classes += ' error';
    if (disabled) classes += ' disabled';
    if (className) classes += ` ${className}`;
    return classes;
  };

  const renderField = () => {
    const commonProps = {
      id: fieldId,
      name,
      value: value || '',
      onChange,
      placeholder,
      required,
      disabled,
      className: getFieldClassName(),
      ...(inputMode ? { inputMode } : {})
    };

    switch (type) {
      case 'select':
        return (
          <select {...commonProps}>
            <option value="">{placeholder || `Seleccionar ${label.toLowerCase()}...`}</option>
            {options.map((option, index) => (
              <option key={option.value || index} value={option.value || option}>
                {option.label || option}
              </option>
            ))}
          </select>
        );

      case 'textarea':
        return (
          <textarea
            {...commonProps}
            rows={rows}
          />
        );

      case 'number':
        return (
          <input
            {...commonProps}
            type="number"
            min={min}
            max={max}
            step={step}
          />
        );

      case 'date':
        return (
          <input
            {...commonProps}
            type="date"
          />
        );

      case 'tel':
        return (
          <input
            {...commonProps}
            type="tel"
          />
        );

      case 'email':
        return (
          <input
            {...commonProps}
            type="email"
          />
        );

      default:
        return (
          <input
            {...commonProps}
            type={type}
          />
        );
    }
  };

  return (
    <div className="form-field">
      <label htmlFor={fieldId} className="form-field-label">
        {icon && <span className="form-field-icon">{icon}</span>}
        {label}
        {required && <span className="required-asterisk">*</span>}
      </label>

      <div className="form-field-input-container">
        {renderField()}
        {error && <div className="form-field-error">{error}</div>}
        {helpText && !error && <div className="form-field-help">{helpText}</div>}
      </div>
    </div>
  );
};

export default FormField;